import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {DELETE, GET, POST, PUT} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseFbResourceAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _getListProxies = (page, limit) => {
    return api.makeAuthRequest({
        url: '/proxies',
        method: GET,
        params: {
            page, limit
        }
    })
}

export const _createNewProxy = (uri) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/proxies',
        data: {
            uri,
        }
    })
}

export const _createNewBulkProxies = (uris, note) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/proxies/bulk',
        data: {
            uris,
            note
        }
    })
}

export const _deleteProxy = (id) => {
    return api.makeAuthRequest({
        method: DELETE,
        url: `/proxies/${id}`,

    })
}

export const _proxyStatistics = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/proxies/statistics`,

    })
}

export const _updateProxyData = (proxyId, updateData) => {
    return api.makeAuthRequest({
        method: PUT,
        url: `/proxies/${proxyId}`,
        data: {
            ...updateData
        },
    })
}



// WEBPACK FOOTER //
// ./src/services/apis/ProxiesServices.js